// extracted by mini-css-extract-plugin
export default {"reactMarkDownOdc":"markdown_reactMarkDownOdc__2Vprh"};